/**
 * service
 */
import taskmanAxios from '../helpers/axios'
import { getAttachmentUploadErrorMessage, getAttachmentValidationMessage } from '../utils/attachmentValidation'
/**
 * const
 */
import {
    API_MAKE_ATTACHMENTS_DELETE_URL,
    API_MAKE_ATTACHMENTS_LIST_URL,
    API_MAKE_ATTACHMENTS_SHOW_URL,
    API_MAKE_ATTACHMENTS_UPLOAD_URL
} from "../constants/api.constant";

export default class AttachmentService {
    static async upload(taskId: number, file: Blob) {
        const filename = (file as File).name || 'file'
        const validationError = getAttachmentValidationMessage([{ name: filename, size: file.size }])
        if (validationError) throw new Error(validationError)

        const formData = new FormData()
        formData.append('file', file)

        return await taskmanAxios.post(API_MAKE_ATTACHMENTS_UPLOAD_URL(taskId), formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                if (response.data?.id == null) {
                    throw new Error('Сервер не подтвердил добавление вложения. Файл не был добавлен к задаче.')
                }
                return response.data
            })
            .catch(error => { throw new Error(getAttachmentUploadErrorMessage(error, filename)) });
    }

    static async list(taskId: number) {
        return await taskmanAxios.get(API_MAKE_ATTACHMENTS_LIST_URL(taskId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async publicUrl(attachmentId: number | string) {
        return await taskmanAxios.get(API_MAKE_ATTACHMENTS_SHOW_URL(attachmentId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async delete(attachmentId: number | string) {
        return await taskmanAxios.delete(API_MAKE_ATTACHMENTS_DELETE_URL(attachmentId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }
}
